import React from 'react';
import { Box, Flex, Text, Button } from '@chakra-ui/react';
import { eyebrowProps, wizardTokens } from '../styles';

interface VisitSummaryCardProps {
  /** Kept for callers; the board's summary list has no heading. */
  title?: string;
  brandName: string;
  brandLogoUrl?: string;
  locationLabel: string;
  timeLabel: string;
  partySizeLabel: string;
  postByLabel?: string;
  postByTitle?: string;
  onEditLocation?: () => void;
  onEditTime?: () => void;
  onEditPartySize?: () => void;
  /** No outline, for use inside another card (the success screen's white panel). */
  bare?: boolean;
}

interface RowProps {
  label: string;
  primary: string;
  secondary?: string;
  onEdit?: () => void;
  last?: boolean;
}

// Board BookVisit review row: eyebrow key, value, sub line, underlined Edit.
const Row: React.FC<RowProps> = ({ label, primary, secondary, onEdit, last }) => (
  <Flex align="center" gap="10px" py="12px" borderBottom={last ? undefined : '1px solid #ECECEA'}>
    <Flex flex={1} minW={0} direction="column" gap="3px">
      <Text {...eyebrowProps} lineHeight="normal">{label}</Text>
      <Text fontSize="16px" fontWeight={600} color={wizardTokens.ink} lineHeight="normal" noOfLines={2}>{primary}</Text>
      {secondary && <Text fontSize="13px" color="#55555A" lineHeight="normal" noOfLines={2}>{secondary}</Text>}
    </Flex>
    {onEdit && (
      <Button
        variant="unstyled"
        flex="none"
        h="44px"
        minW={0}
        px="4px"
        fontFamily="display"
        fontSize="14px"
        fontWeight={600}
        color={wizardTokens.ink}
        textDecoration="underline"
        aria-label={`Edit ${label}`}
        onClick={onEdit}
      >
        Edit
      </Button>
    )}
  </Flex>
);

// Shared visit summary used by the review step (pre-confirm) and the success screen
// (post-confirm) so the summary always looks and reads the same.
const VisitSummaryCard: React.FC<VisitSummaryCardProps> = ({
  brandName,
  locationLabel,
  timeLabel,
  partySizeLabel,
  postByLabel,
  postByTitle = 'Content due by',
  onEditLocation,
  onEditTime,
  onEditPartySize,
  bare = false,
}) => (
  <Box border={bare ? undefined : '1px solid #E4E4E0'} borderRadius="18px" px={bare ? '18px' : '14px'} py={bare ? '6px' : 0} bg="#FFFFFF" fontFamily="display">
    <Row label="Party Size" primary={partySizeLabel} onEdit={onEditPartySize} />
    <Row label="Location" primary={brandName} secondary={locationLabel} onEdit={onEditLocation} />
    <Row label="Date & Time" primary={timeLabel} onEdit={onEditTime} last={!postByLabel} />
    {postByLabel && <Row label={postByTitle} primary={postByLabel} last />}
  </Box>
);

export default VisitSummaryCard;
